import { Box, Collapse, List, Typography, useMediaQuery, useTheme } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import classnames from 'classnames'
import React, { useMemo, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { removeTrailingSlash } from '../../../lib/helper/commonHelper'
import { mobileBreakpoint } from '../../../lib/helper/viewportHelper'
import AppMenuItemComponent from '../AppMenuItemComponent/AppMenuItemComponent'
import useStyles from './styles'

// varför går det inte att skicka props id, namn och collections som ett enda objekt? det blir undefined av någon okänd anledning i vissa fall på desktop 
const AppMenuItem = ({ id, name, collections, indent, onItemClick, makeHistory, selectCollection }) => {
    const collection = {id, name, collections}
    const classes = useStyles()
    const isExpandable = collections && collections.length > 0
    const [open, setOpen] = useState(false)
    const theme = useTheme()
    const marginLeft = theme.spacing(indent)
    const isMobile = useMediaQuery(theme.breakpoints.down(mobileBreakpoint))
    const isOpen = useMemo(()=> isMobile ? false : open, [isMobile, open])


    const toggleOpen = () => {
        setOpen((prev) => !prev)
    }

    const { url } = useRouteMatch()

    const MenuItemRoot = (
        <Box onClick={() => { if (!isExpandable) onItemClick(id) }}>
            <AppMenuItemComponent className={classes.menuItem} link={isExpandable ? null : `${removeTrailingSlash(url)}/filter`} makeHistory={makeHistory}>
                { /* Icon handling */}
                {!isExpandable ?
                    <Typography variant='body2' style={{ marginLeft: marginLeft + 24 /* offset by width of an icon */ }}>{name}</Typography>
                    : null
                }
                {isExpandable && 
                    <div onClick={toggleOpen} style={{ marginLeft: marginLeft + 24 }} className={classes.categoryArea}>
                        <Typography variant='body2' onClick={() => isMobile ? selectCollection(collection): null}>{name}</Typography>
                        <ExpandMoreIcon className={classnames(classes.icon, isOpen && classes.openTransform)} />
                    </div>
                }
            </AppMenuItemComponent>
        </Box>
    )

    const MenuItemChildren = isExpandable ? (
        <Collapse in={isOpen} timeout='auto' unmountOnExit>
            <List
                component='div'
                disablePadding
            >
                {collections.map((collection, i) => (
                    <AppMenuItem key={i} {...collection} indent={indent + 2} isOpen={isOpen} onItemClick={onItemClick} makeHistory={makeHistory}/>
                ))}
            </List>
        </Collapse>
    ) : null

    return (
        <>
            {MenuItemRoot}
            {MenuItemChildren}
        </>
    )
}

export default AppMenuItem
